import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { CardsApi, type GetAllInvoicesResponse } from '@shared/api';

interface UseAllInvoicesStore {
  loading: boolean;
  data: GetAllInvoicesResponse[];
  error: string | null;
  getAllInvoicesCard: (cardId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useAllInvoicesStore = create<UseAllInvoicesStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getAllInvoicesCard: ApiUtils.wrapperApi(async (cardId, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await CardsApi.getAllInvoicesCard(cardId, signal);
      set({ data: result || [], loading: false });
    } catch (error) {
      set({ loading: false, data: [], error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
